import { CLIENTS } from "@/content";

export const Clients = ({ t, lang }) => {
  const list = CLIENTS[lang];
  return (
    <section className="border-y border-ink/20 bg-ink text-paper" data-testid="clients-strip">
      <p className="lb text-brasssoft max-w-6xl mx-auto px-6 pt-6">{t.clientsLabel}</p>
      <div className="overflow-hidden" dir="ltr">
        <div className="mq dd italic text-3xl py-5">
          {list.map((c) => (
            <span className="px-10 whitespace-nowrap" key={c}>{c}</span>
          ))}
          {list.map((c) => (
            <span className="px-10 whitespace-nowrap" key={`d-${c}`} aria-hidden="true">{c}</span>
          ))}
        </div>
      </div>
    </section>
  );
};
